import posthog from 'posthog-js';
import { getConsent, onConsentChange } from './consent';

// ponytail: public write-only key, PostHog explicitly marks it safe for client bundles
const KEY = 'phc_yvTMhNdm5RfxiXxAew5imhjxChbJBpXGJQRgxrH8rEZS';

export function initPostHog() {
  if (!KEY) return;

  posthog.init(KEY, {
    api_host: 'https://eu.i.posthog.com',
    autocapture: false,
    capture_pageview: false,
    loaded: (ph) => {
      if (getConsent() !== 'granted') ph.opt_out_capturing();
    },
  });

  onConsentChange((value) => {
    if (value === 'granted') posthog.opt_in_capturing();
    else posthog.opt_out_capturing();
  });
}

export function capture(event, props = {}) {
  if (!KEY || getConsent() !== 'granted') return;
  posthog.capture(event, props);
}
